import StoryVideo from './StoryVideo.vue';
import StoryVideoList from './StoryVideoList.vue';
export default {
  StoryVideo,
  StoryVideoList,
};
